// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__Ukv-0","image":"recipe_image__mYwrE","title":"recipe_title__7nExL","li":"recipe_li__RrMNl"};